<script lang="ts" setup>
	import { twMerge, type ClassNameValue } from 'tailwind-merge'

	const { rowCount = 2, ...props } = defineProps<{
		rowCount?: number
		filterList?: string[]
		disableAnimation?: boolean
		imgClass?: ClassNameValue
		wrapperCls?: ClassNameValue
	}>()
	const imageList = ref<string[]>([])
	onMounted(async () => {
		const images = import.meta.glob('/public/img/providers/*.{png,jpg,jpeg,svg}')
		let imagesKeys = Object.keys(images)
		const propList = props?.filterList
		if (propList && Array.isArray(propList) && propList.length) {
			imagesKeys = imagesKeys.filter(key => propList.includes(key))
		}
		imageList.value = await Promise.all(
			imagesKeys.map(async path => {
				let img = (await images[path]()) as { default: any }
				return img.default
			})
		)
	})
</script>
<template>
	<div class="overflow-hidden">
		<div
			:class="[
				twMerge('flex w-full items-center gap-x-5', wrapperCls),
				{
					moveX: !disableAnimation
				}
			]"
			:style="{
				'--animation-move-count': (imageList?.length ?? 1) + 3
			}"
		>
			<template v-for="(_, count) in rowCount" :key="`provider-count-${count}`">
				<img
					v-for="(item, index) in imageList"
					:key="index"
					:alt="item"
					:src="item"
					:height="52.9691"
					:width="134.9857"
					loading="lazy"
					:class="twMerge('object-scale-down flex-none max-h-[24px]', imgClass)"
				/>
			</template>
		</div>
	</div>
</template>
